module.exports = __webpack_public_path__ + "img/lose.181d9747.png";